module.exports = __webpack_public_path__ + "img/logo.72fa16a3.png";